import { Title } from '../../../components'
import {
    Container
} from './styles'

export default function (){
    return (
        <Container>
            <div className="row">
                <div className="col">
                    <Title>Back-Up</Title>

                    <section className="mt-2 p-3">

                        <ul>
                            <li>Scout;</li>
                            <li>Axial P.M. bilateral;</li>
                            <li>Axial Osso bilateral;</li>
                            <li>Axial P.M. direito;</li>
                            <li>Axial P.M. esquerdo;</li>
                            <li>Axial Osso direito;</li>
                            <li>Axial Osso esquerdo;</li>
                            <li>Sagital P.M. direito;</li>
                            <li>Sagital P.M. esquerdo;</li>
                            <li>Sagital Osso direito;</li>
                            <li>Sagital Osso esquerdo;</li>
                            <li>Coronal P.M. direito;</li>
                            <li>Coronal P.M. esquerdo;</li>
                            <li>Coronal Osso direito;</li>
                            <li>Coronal Osso esquerdo;</li>
                            <li>Relatório de dose;</li>
                        </ul>
                    </section>
                </div>
            </div>
        </Container>
    )
}